export const DEFAULT_CATEGORY_SELECTION = "all-articles";
